import React from "react";
import HeaderNavigationMolecule from "../components/molecules/HeaderNavigationMolecule";
import Body from "./body/body";

function App() {
  document.addEventListener("scroll", function () {
    var scrollPosition = window.scrollY || document.documentElement.scrollTop;
    var header = document.querySelectorAll(".header");
    //색 초기화
    header[0].style.color = "#000000";
    header[1].style.color = "#000000";
    header[2].style.color = "#000000";
    // scroll위치에 따른 header[i]별 색 변경
    for (var i = 0; i <= header.length - 1; i++) {
      if (
        scrollPosition >
          document.getElementById("body-content" + (i + 1)).offsetTop - 500 &&
        scrollPosition <=
          document.getElementById("body-content" + (i + 2)).offsetTop - 500 &&
        i >= 1
      ) {
        header[i - 1].style.color = "#ffb039";
      } else if (
        scrollPosition >
          document.getElementById("body-content" + (i + 1)).offsetTop - 500 &&
        i == 2
      ) {
        header[i].style.color = "#ffb039";
      }
    }
  });
  return (
    <div>
      <HeaderNavigationMolecule />
      <Body></Body>
    </div>
  );
}

export default App;
